export default __webpack_public_path__ + "static/media/Ellipse_Orange.1c81213a.svg";